const STATUS_URL = 'https://waas.sequence.app/status';
const PROBE_TIMEOUT_MS = 3000;

export type SequenceAvailabilityReason = 'ok' | 'blocked-451' | 'network-error';

export interface SequenceAvailability {
  available: boolean;
  reason: SequenceAvailabilityReason;
}

let cached: Promise<SequenceAvailability> | null = null;

async function runProbe(): Promise<SequenceAvailability> {
  if (import.meta.env.VITE_FORCE_SEQUENCE_BLOCKED === 'true') {
    return { available: false, reason: 'blocked-451' };
  }

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);

  try {
    const response = await fetch(STATUS_URL, {
      method: 'GET',
      signal: controller.signal,
    });

    if (response.status === 451) {
      return { available: false, reason: 'blocked-451' };
    }
    if (!response.ok) {
      return { available: false, reason: 'network-error' };
    }
    return { available: true, reason: 'ok' };
  } catch {
    return { available: false, reason: 'network-error' };
  } finally {
    clearTimeout(timer);
  }
}

export function probeSequenceAvailability(): Promise<SequenceAvailability> {
  if (!cached) {
    cached = runProbe();
  }
  return cached;
}

export function resetSequenceAvailabilityCache(): void {
  cached = null;
}
